import React from "react";
import { UserDrawer, Box } from "@InnoUI";
import { useSelector } from "react-redux";
import { canWrite } from "@utils/helper";

const FolderDrawerLayout = ({ drawerItems = [] }) => {
  const authData = useSelector((state) => state.authdata);

  const filteredRoutes = drawerItems;

  return (
    <Box>
      <UserDrawer navItems={filteredRoutes} />
    </Box>
  );
};

export default FolderDrawerLayout;
